var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4536 8.17864C12.2062 7.94045 11.7938 7.94045 11.5464 8.17864L6.18557 13.3129C5.93814 13.5775 5.93814 13.9745 6.18557 14.2127L6.81787 14.8214C7.06529 15.0595 7.47766 15.0595 7.75258 14.8214L12.0137 10.7457L16.2474 14.8214C16.5223 15.0595 16.9347 15.0595 17.1821 14.8214L17.8144 14.2127C18.0619 13.9745 18.0619 13.5775 17.8144 13.3129L12.4536 8.17864Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.44e4de4ce4235d72eccf9c16aea021bc.svg";
export { ForwardRef as ReactComponent };